import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * rancho.store.ts (2026-09-27) — Rancho activo del dashboard.
 *
 * Distinto de `project.store.ts`: un Proyecto es una temporada/ciclo dentro
 * de UN rancho (`Project.ranchoId`), no un selector de ubicación física.
 * Antes de este store, páginas como `FieldPage` mostraban lotes de TODOS los
 * ranchos del tenant mezclados sin ningún filtro — este store es el mismo
 * patrón que `useProjectStore` pero para el concepto que faltaba.
 *
 * `null` = todos los ranchos (sin filtrar) — comportamiento por defecto para
 * un usuario con un solo rancho, o que aún no ha elegido uno.
 */
interface RanchoState {
  activeRanchoId: string | null;
  activeRanchoName: string | null;
  setActiveRancho: (ranchoId: string | null, name?: string | null) => void;
  clearActiveRancho: () => void;
}

export const useRanchoStore = create<RanchoState>()(
  persist(
    (set) => ({
      activeRanchoId: null,
      activeRanchoName: null,
      setActiveRancho: (ranchoId, name) =>
        set({ activeRanchoId: ranchoId, activeRanchoName: ranchoId ? name ?? null : null }),
      clearActiveRancho: () => set({ activeRanchoId: null, activeRanchoName: null }),
    }),
    { name: 'agrovid-rancho' },
  ),
);
